<template>
    <div>
<!--        <div className="temp-text temp-text-first">Персональні дані</div>-->
        <div class="cabinet-select__wrapper">
            <cabinet-select-item v-for="group in groups" :group="group" :count="group.length"/>
        </div>
        <div class="cabinet-select__new-item" >
            <edit-favorite-item v-if="addFavorite" @showEditSettings="showEditSettings" :addFavorite="addFavorite" />
            <button @click="addFavorite = true" v-else>{{ message.btnAddNewGroup }}</button>
        </div>

<!--        <div className="temp-text">Історія замовлень</div>-->

<!--        <cabinet-history/>-->
    </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
    name: "favorites-vue",
    data(){
        return{
            addFavorite: false,
        }
    },
    methods: {
        showEditSettings(edit){
            this.addFavorite = edit;
        },
    },
    computed: {
        ...mapState({
            routes: ({ favourite }) => favourite?.data?.routes,
            groups: ({ favourite }) => favourite?.data?.group,
            message: ({ favourite }) => favourite?.data?.message,
        })
    }
}
</script>

<style scoped lang="scss">


.cabinet-select__new-item {
    margin-top: 18px;

    //width: rem(222);
    //height: rem(48);
    //background-color: #618EAF;
    //display: flex;
    //justify-content: center;
    //align-items: center;
    //cursor: pointer;

    button {
        display: block;
        height: 48px;
        background: #618EAF;
        color: #fff;
        font-size: rem(14);
        padding: 0 48px;
        transition: .2s linear background;
        letter-spacing: 0.08em;
        text-transform: uppercase;
        font-weight: 500;

        @include point-md{
            margin-right: 16px;
        }

        &:hover{
            background: rgba(97, 142, 175, .8);
            transition: .2s linear background;
        }
    }
}

.temp-text {
    margin-top: 120px;
    font-size: 24px;
}

.temp-text-first {
    margin-top: 0;
}

::v-deep{

    input[type="checkbox"]{
        display: none;

        &:checked + span{
            content: '';
            width: 8px;
            height: 8px;
            display: block;
            background: #618EAF;
            position: absolute;
            top: 4px;
            left: 4px;

        }
    }
    label{
        position: relative;
        font-weight: 500;
        font-size: 16px;
        text-align: center;
        color: #191918;

        display: flex;
    }
    label:before{
        content: '';
        width: 16px;
        height: 16px;
        border: 1px solid #DFDFDF;
        margin-right: 12px;
    }
}

</style>